// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-action[data-v-4f3ad4db]{width:150px;height:150px}.file-container[data-v-4f3ad4db]{min-height:100px;padding-bottom:50px;border:1rem}.tips[data-v-4f3ad4db]{border:5px;padding:5px}.tips p[data-v-4f3ad4db]{font-size:large;font-weight:700}.tip li[data-v-4f3ad4db]{padding-block-start:1rem;font-size:medium;font-weight:400;font-family:Times New Roman,Times,serif}.ivu-row[data-v-4f3ad4db]{padding-top:10px}", ""]);
// Exports
module.exports = exports;
